import Vue from 'vue'
import Vuex from 'vuex'
import { userKey} from '@/config/global'
import axios from 'axios'
import '@/config/loading'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // variaveis globais
        user: null,
        aovivo: null,
    },
    getters: {
        // get das variaveis
        
        getUser(state) {
            return state.user;
        },

        getAoVivo(state) {
            return state.aovivo;
        },

        getIdContrato(state) {
            return state.autenticacao.idContrato;
        }

    },
    mutations: {
        // troca valores das variaveis
        setUser(state, user) {
            state.user = user
            if (user) {
                localStorage.setItem(userKey, JSON.stringify(user))
                axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`
            } else {
                localStorage.removeItem(userKey)
                delete axios.defaults.headers.common['Authorization']
            }
        },
     
        setLoading(state, loading) {
            state.loading = loading
        },

        setAoVivo(state, aovivo) {
            state.aovivo = aovivo
        },

        showLoading(state, parameters) {
            state.loading = state.loading.show(parameters);
        },

        hideLoading(state) {
            state.loading.hide();
            state.loading = Vue.$loading;
        },

    },
    actions: {
        // logicas de trocar valores
        
    }
});

export default store;